import { Box, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { rem, renderNoti } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";
import StampWrap from "components/stamp/stamp-wrap";
import Loading from "components/ui/loading";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme) => ({
  stampDetail: {
    "& .top": {
      display: "flex",
      "& img": {
        width: "100%",
      },
    },
    "& .bottom": {
      display: "flex",
      "& img": {
        width: "100%",
      },
    },
    "& .info": {
      padding: `${rem(35)} ${rem(30)} ${rem(45)}`,
      // borderTop: "12px solid #F6F6F6",
      borderBottom: "1px solid #F5F5F5",
      "& table": {
        fontSize: rem(14),
        borderCollapse: 0,
        borderSpacing: 0,
        "& tr": {
          "& th": {
            width: rem(85),
            textAlign: "left",
            fontWeight: 800,
            verticalAlign: "top",
            lineHeight: rem(22),
            padding: `${rem(5)} 0`,
          },

          "& td": {
            wordBreak: "keep-all",
            lineHeight: rem(22),
            padding: `${rem(5)} 0`,
          },

          "& + tr": {
            marginTop: rem(6),
          },
        },
      },
    },
  },
}));

export default function Stamp(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { seq } = useParams();

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [detailData, setDetailData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);

  const [fetching, setFetching] = useState(true);

  const fetchData = async () => {
    await axios
      .get("/api/eh/stamp/get", {
        params: {
          seq: seq,
          schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
          storeCode: storeCode,
        },
      })
      .then((res) => {
        if (res.data.data.stamp) {
          setDetailData({
            ...res.data.data.stamp,
          });
          setIsDisabled(res.data.data.isDisabled);
        } else {
          history.replace("/notFound");
        }
        setFetching(false);
      })
      .catch((error) => {
        history.replace("/notFound");
        setFetching(false);
      });
  };

  useEffect(() => {
    setFetching(true);
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "스탬프", menu: false }));
  }, [init]);

  const renderNoti = (item) => {
    if (item) return item.split("\n");
    return [];
  };

  return (
    <>
      <Loading open={fetching} />
      <main id="main" className={"container nopad " + classes.stampDetail}>
        <div className="top">
          <img src={detailData.topImgUrl} />
        </div>
        <div
          style={{
            backgroundImage: `${"url(" + detailData.bgImgUrl + ")"}`,
            backgroundSize: "100% auto",
            backgroundRepeat: "no-repeat",
          }}
        >
          <StampWrap detailData={detailData} isDisabled={isDisabled} bgYn="N" fetchData={fetchData} />
        </div>

        <div className="bottom">
          <img src={detailData.botImgUrl} />
        </div>

        {detailData.stampFlag == "2" && <Divider className="divider-type-2" />}

        <div className="info">
          <table>
            {detailData.ptcp && (
              <tr>
                <th>참여 방법</th>
                <td>
                  <ul className="list">
                    {renderNoti(detailData.ptcp).map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            )}
            <tr>
              <th>행사 기간</th>
              <td>
                {moment(detailData.startDate).format("YYYY.MM.DD")}
                {" ~ "}
                {moment(detailData.endDate).format("YYYY.MM.DD")}
              </td>
            </tr>
            {detailData.accStd && (
              <tr>
                <th>적립 기준</th>
                <td>
                  <ul className="list">
                    {renderNoti(detailData.accStd).map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            )}
            <tr>
              <th>적립 매장</th>
              <td>{detailData.storeName}</td>
            </tr>
          </table>
        </div>
        {detailData.noti && (
          <Box className="notice is-bottom">
            <p className="title">
              <i className="ico-noti" />
              유의사항
            </p>
            <ul className="list list-dot color-info font-14">
              {renderNoti(detailData.noti).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </Box>
        )}
      </main>
    </>
  );
}
